import { render, staticRenderFns } from "./SchematicSidebar.vue?vue&type=template&id=6baac1b2&scoped=true"
import script from "./SchematicSidebar.vue?vue&type=script&lang=js"
export * from "./SchematicSidebar.vue?vue&type=script&lang=js"
import style0 from "./SchematicSidebar.vue?vue&type=style&index=0&id=6baac1b2&prod&lang=css"
import style1 from "./SchematicSidebar.vue?vue&type=style&index=1&id=6baac1b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6baac1b2",
  null
  
)

export default component.exports